import * as React from "react";

import { Nullable } from "types";

interface PropsType {
  error: Nullable<string>;
}

export default function FieldError(props: PropsType): JSX.Element {
  const { error } = props;

  if (!error) return null;

  return <span className="form--field-error">{error}</span>;
}
